import React from "react";
import { useMemo } from "react";
import Text from "src/components/text";
import moment from "moment";

import { Analytics, DealRoomItem } from "src/types/reports";

import _ from "lodash";
import cx from "classnames";
import styles from "./dealRoomListItem.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface DealRoomActivityItem {
  dealRoom: DealRoomItem;
  analytics: Analytics;
}

export interface DealRoomListItemProps {
  item: DealRoomActivityItem;
  columnCount: number;
}

export const DealRoomListItem: React.FC<DealRoomListItemProps> = ({
  item,
  columnCount,
}) => {
  const { dealRoom, analytics } = item;

  const createdBy = useMemo(() => {
    return dealRoom.createdBy?.firstName
      ? `${dealRoom.createdBy.firstName} ${dealRoom.createdBy.lastName || ""}`.trim()
      : "Unknown";
  }, [dealRoom.createdBy]);

  const thumbnail = useMemo(() => {
    return dealRoom.icon?.thumbnail || DefaultAssetIcon;
  }, [dealRoom.icon?.thumbnail]);

  return (
    <div key={dealRoom.dealRoomId} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={thumbnail}
          alt={_.get(dealRoom, "name", "")}
          className={styles.thumbnailIcon}
        />
        <a
          href={`/deal-room/${dealRoom.dealRoomId}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text
                lines={1}
                className={styles.title}
                text={_.get(dealRoom, "name", "")}
              />
            </div>
            <span className={styles.metricsData}>
              <span className={styles.name}>
                {dealRoom.assetsCount || 0} Assets
              </span>
            </span>
          </div>
        </a>
      </div>
      <div
        className={cx(styles.analyticsContainer)}
        style={{ gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))` }}
      >
        <div className={styles.tableDataViews}>
          <Text lines={1} className={styles.author} text={createdBy} />
        </div>
        <div className={styles.tableDataViews}>
          {dealRoom.createdDate && moment(dealRoom.createdDate).format("DD MMM YYYY")}
        </div>
        <div className={styles.tableDataViews}>
          {dealRoom.modifiedDate && moment(dealRoom.modifiedDate).format("DD MMM YYYY")}
        </div>
        <div className={styles.tableDataViews}>{_.get(analytics, "views", 0)}</div>
        <div className={styles.tableDataShares}>{_.get(dealRoom, "totalPeopleInvolved", 0)}</div>
        <div className={styles.tableDataShares}>{_.get(dealRoom, "totalInteractionsInvolved", 0)}</div>
      </div>
    </div>
  );
};
